import { set, toggle } from '@/utils/vuex'

export default {
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  setSnackbar: set('snackbar'),
  snack (state, { message, color = 'primary', positions = [] }) {
    for (const loc of positions) {
      state[loc] = true
    }
    
    state.message = message
    state.snackbarColor = color   

    state.snackbar = true
  },
  setDialog: set('dialog'),
  dialog (state, { title, message, color = 'primary' }) {
    state.dialogTitle = title 
    state.dialogMessage = message
    state.dialogColor = color

    state.dialog = true
  },
}
